import { SWRConfiguration, SWRResponse } from 'swr';
import { Authenticate, AuthenticateResponse } from '@/dtos';
import usePost from './api/usePost';

const request = () => {
    return new Authenticate();
};

const getData = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => response?.data;
const getError = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useAuthenticatedUser = (configuration: SWRConfiguration) => {
    return usePost(request, { getData, getError }, configuration);
};

export default useAuthenticatedUser;

